import React from 'react';
var WindowUpdateContentContext = React.createContext(null);
export var WindowUpdateContentProvider = WindowUpdateContentContext.Provider;
export var WindowUpdateContentConsumer = WindowUpdateContentContext.Consumer;
export default WindowUpdateContentContext;
//# sourceMappingURL=window-update-content-context.js.map